import React from 'react';
import type { InputHTMLAttributes } from 'react';
import { Field } from 'react-final-form';

import styles from './FileField.module.css';
import upload from 'assets/icons/upload.png';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  name: string
}

const FileField = ({ name, ...props }: Props) => (
  <Field<FileList> name={name}>
    {/* eslint-disable-next-line @typescript-eslint/no-unused-vars */}
    {({ input: { value, onChange, ...input } }) => (
      <label className={styles.inputContainer} htmlFor="input-file-upload">
        <input
          {...input}
          type="file"
          onChange={({ target }) => onChange(target.files)} // instead of the default target.value
          {...props}
          className={styles.input}
          multiple
          id="input-file-upload"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        />
        <div className={styles.contentContainer}>
          <div className={styles.contentBody}>
            <img src={upload} alt="delete icon" />
            <span className={styles.drag}>Drag & Drop or{' '}<span className={styles.choose}>Choose File</span></span>
          </div>
          <span className={styles.description}>Supports XLS and XLSX file up to 5MB</span>
        </div>
      </label>
    )}
  </Field>
);

export default FileField;
